module.exports = __webpack_public_path__ + "img/clock.51bcf183.svg";